import { Module } from 'vuex'
import { IProfileState, ProfileStoreContext } from './profile.types'
import {
  INotificationsOutputNotification,
  IProfileOutputMetrics,
} from '@/api/types/response.types'
import { IRootState, IErrorState } from '@/services/store/store.types'
import * as actionTypes from '@/services/store/action-types'
import * as mutationTypes from '@/services/store/mutation-types'
import { IProfile } from '@/types/data-objects/profile'
import ProfileAPI from '@/api/modules/profile.api'
import NotificationsAPI from '@/api/modules/notifications.api'

export const profileStore: Module<IProfileState, IRootState> = {
  namespaced: true,
  state: {
    data: {
      id: null,
      name: '',
      accountRole: null,
      featureRole: null,
      photoUrl: '',
      fromWebex: false,
      listAccounts: [],
      sampleInternalProjectIDsForAccount: [],
      featureEnablement: null,
      isImpersonating: false,
    },
    notifications: [] as INotificationsOutputNotification[],
    isLoading: false,
    error: {
      code: 0,
      isError: false,
      message: '',
    },
  } as IProfileState,
  mutations: {
    [mutationTypes.PROFILE_TOGGLE_LOADING](profile: IProfileState) {
      profile.isLoading = !profile.isLoading
    },

    [mutationTypes.PROFILE_SET_ERROR](
      profile: IProfileState,
      payload: IErrorState,
    ) {
      profile.error = payload
    },

    [mutationTypes.PROFILE_SET_DATA](
      profile: IProfileState,
      payload: IProfile,
    ) {
      profile.data = payload
    },

    [mutationTypes.PROFILE_METRICS_SET_DATA](
      profile: IProfileState,
      payload: IProfileOutputMetrics,
    ) {
      profile.data.profileMetrics = payload
    },

    [mutationTypes.NOTIFICATIONS_SET_DATA](
      profile: IProfileState,
      payload: INotificationsOutputNotification[],
    ) {
      profile.notifications = payload
    },
  },
  actions: {
    async [actionTypes.PROFILE_FETCH]({ commit }: ProfileStoreContext) {
      try {
        commit(mutationTypes.PROFILE_TOGGLE_LOADING)
        const resp = await ProfileAPI.get_Index()
        commit(mutationTypes.PROFILE_SET_DATA, resp)
        return resp
      } finally {
        commit(mutationTypes.PROFILE_TOGGLE_LOADING)
      }
    },
    async [actionTypes.PROFILE_METRICS_FETCH]({ commit }: ProfileStoreContext) {
      try {
        commit(mutationTypes.PROFILE_TOGGLE_LOADING)
        const resp = await ProfileAPI.get_Metrics()
        commit(mutationTypes.PROFILE_METRICS_SET_DATA, resp)
        return resp
      } finally {
        commit(mutationTypes.PROFILE_TOGGLE_LOADING)
      }
    },
    async [actionTypes.NOTIFICATIONS_FETCH]({ commit }: ProfileStoreContext) {
      const resp = await NotificationsAPI.get_Listing()
      commit(mutationTypes.NOTIFICATIONS_SET_DATA, resp)
      return resp
    },
  },
  getters: {
    currentCompany(state: IProfileState) {
      const currentCompany = state.data.listAccounts.find(
        item => item.current === true,
      )
      return currentCompany
    },
    isAdminOrOwner(state: IProfileState) {
      return [2, 3].includes(state.data.accountRole)
    },
  },
}
